module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.57.6e3500da.jpg";